import React from 'react';
import { useQuery } from '@tanstack/react-query';
import kid from '../../../../assets/retake-confirmation-girl.jpg';
import useQueryString from '../../../../hooks/use-query-string';
import { Djob, Student, StudentImage } from '../../../../models';
import './confirmation.scss';
import routes from "../../../../routes";
import { useHistory } from "react-router-dom";

function useStudentImages(schoolId, studentId) {
  return useQuery(['STUDENT_IMAGES', schoolId, studentId], () => (
    Student
      .where({ schoolId, studentId, is_enrolled: true })
      .first()
      .then(async (studentRes) => (
        StudentImage
          .where({ studentId: studentRes.data.id, forCurrentSeason: true })
          .first()
          .then((studentImageRes) => studentImageRes.data)
      ))
  ));
}

function useStudent(schoolId, studentId) {
  return useQuery(['STUDENT', schoolId, studentId], () => (
    Student
      .includes('school')
      .where({ schoolId, studentId })
      .first()
      .then((res) => res.data)
  ));
}

function useDjobs(schoolId) {
  return useQuery(['DJOBS', schoolId], () => (
    Djob
      .where({ closest_retake_date_for_school: schoolId })
      .first()
      .then(djobRes => djobRes.data)
  ));
}

export default function Confirmation() {
  const { sch: schoolId, sid: studentId, season: season, access_code: accessCode } = useQueryString();
  const { data: student } = useStudent(schoolId, studentId);
  const { data: djob } = useDjobs(schoolId);
  const { isLoading, data: studentImage } = useStudentImages(schoolId, studentId);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    studentImage.needsRetake = true;

    const res = await studentImage.save();

    if (res) history.push(routes.retakes.home({ sch: schoolId, sid: studentId, season: season, access_code: accessCode }));
  };

  return (
    <div className="retake-confirmation-page">
      <div className="container">
        <div className="col-md-6 col-md-offset-3">
          <img alt="Retake Banner Kid" src={kid} />
          {student && (
            <>
              <div className="retake-info">
                <p>Retake Request Confirmed for:</p>
                <p className="largeText">{`${student.firstName} ${student.lastName}`}</p>

                <div className="studentInfo">
                  <p>{student.school.name}</p>
                  <p>Retake Picture Day</p>
                  {djob && djob.date && (
                    <p className="largeText">{djob.date}</p>
                  )}
                </div>
              </div>
              <p className="bottomText">
                There is nothing to hand in. Your student
                will be photographed during the school
                day. You will be notified when your Retake
                Picture is ready to view and purchase.
              </p>

              <p className="bottomText">
                Need to cancel your retake request? Click the button below.
              </p>
              <form onSubmit={handleSubmit}>
                <button disabled={isLoading} className="submit-btn" type="submit">Click Here</button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
